import React from 'react';
import { StyledPaper, LoadingContainer, Content } from './styles';

export const Paper: React.FC<PaperProps> = ({
  isLoading,
  children,
  className,
  loadingContent,
  withSpacing = true,
  containerRef,
}) => {
  return (
    <StyledPaper
      ref={containerRef}
      className={className}
      $isLoading={isLoading}
      $withSpacing={withSpacing}
    >
      <Content>{children}</Content>
      <LoadingContainer>{loadingContent}</LoadingContainer>
    </StyledPaper>
  );
};

export interface PaperProps {
  isLoading?: boolean;
  className?: string;
  loadingContent?: React.ReactNode;
  withSpacing?: boolean;
  containerRef?: React.RefObject<HTMLDivElement>;
}
